import { gql } from "@apollo/client";

export const GetSurveyResponseCount = gql`
  query GetSurveyResponseCount($survey_id: bigint!, $phone: String!) {
    survey_responses_aggregate(
      where: {
        survey_id: { _eq: $survey_id }
        user: { phone_number: { _eq: $phone } }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;